import css from './PostView.module.scss';
import i18n from 'i18next';
import {useEffect, useState} from 'react';
import H5title from '../titles/H5title';
import classNames from 'classnames';
import {useTranslation} from 'react-i18next';
import PostSection from './PostSection';
import RichMdViewer from '../md-viewer/RichMdViewer';
import Container from '../container/Container';
import PostNavigation from './PostNavigation';
import {useBlogContext} from '../BlogContext';

export default function PostView({id, type}) {
  const {t} = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'ru';
  const [metadata, setMetadata] = useState(null);
  const [file, setFile] = useState(null);
  const {blogPosts, saveBlogPost} = useBlogContext();

  useEffect(() => {
    fetch(`/blog/${id}/${lang}/metadata.json`)
      .then(res => res.json())
      .then(text => {
        setMetadata(text)
      });

    if (type === 'post') {
      if (!blogPosts[id] || !blogPosts[id][lang]) {
        fetch(`/blog/${id}/${lang}/post.md`)
          .then(res => res.text())
          .then(text => {
            setFile(text)
            saveBlogPost(id, text, lang)
          });
      } else {
        setFile(blogPosts[id][lang])
      }
    }
  }, [blogPosts, saveBlogPost, lang, id, type]);

  if (!metadata) {
    return (
      <div>...</div>
    );
  }

  return (
    <>
      {
        type === 'post' && (
          <>
            <PostSection id={id} metadata={metadata}/>
            <Container>
              <RichMdViewer file={file} basePath={`/blog/${id}/${lang}`}/>
              <PostNavigation id={id}/>
            </Container>
          </>
        )
      }
      {
        type === 'short' && (
          <div role="listitem" className={css.blogPostItem}>
            <a href={`/#/blog/${id}`} className={classNames(css.a, css.blogPostImageWrap)}>
              <img loading="lazy"
                   src={metadata.heroImage ? `/blog/${id}/${lang}/${metadata.heroImage}` : `/blog/${id}/${lang}/img.png`}
                   className={css.blogPostImage} alt={'blog_image'}/>
            </a>
            <div className={css.blogPostText}>
              <div className={css.category}>{metadata.tag}</div>
              <div className={css.blogAdditionalInfo}>
                <div className={css.additionalInfoText}>{metadata.date}</div>
                <div className={css.row}>
                  <div className={css.additionalInfoText}>{metadata.TTR}</div>
                </div>
              </div>
              <a href={`/#/blog/${id}`} className={classNames(css.a, css.inlineBlock)}>
                <H5title>
                  {metadata.title}
                </H5title>
              </a>
              <p>{metadata.description}</p>
              <div className={css.linkWrapper}>
                <a href={`/#/blog/${id}`} className={classNames(css.a, css.linkWithIcon)}>{t('blog.read-more')} &rarr;</a>
              </div>
            </div>
          </div>
        )
      }
    </>
  );
}